"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkerExtension = exports.MarkerBehavior = exports.DefaultMarkerExtensionParams = void 0;
var tslib_1 = require("tslib");
var class_names_1 = require("../class-names");
var extension_1 = require("../extension");
var scales_1 = require("../scales");
var utils_1 = require("../utils");
/** Default parameter values for `MarkerExtension` */
exports.DefaultMarkerExtensionParams = {
    markerCornerRadius: 1,
    freeze: false,
};
/** Behavior class for `MarkerExtension` (highlights hovered grid cell and column and row) */
var MarkerBehavior = /** @class */ (function (_super) {
    tslib_1.__extends(MarkerBehavior, _super);
    function MarkerBehavior() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentlyMarked = { xIndex: undefined, yIndex: undefined };
        return _this;
    }
    MarkerBehavior.prototype.register = function () {
        var _this = this;
        _super.prototype.register.call(this);
        this.subscribe(this.state.events.hover, function (pointed) {
            var _a;
            if (!_this.params.freeze) {
                var hasDatum = ((_a = pointed.cell) === null || _a === void 0 ? void 0 : _a.datum) !== undefined;
                _this.drawMarkers(hasDatum ? pointed.cell : undefined);
            }
        });
        this.subscribe(this.state.events.resize, function () {
            _this.drawMarkers(_this.currentlyMarked);
        });
        this.subscribe(this.state.events.zoom, function () {
            _this.drawMarkers(_this.currentlyMarked);
        });
    };
    /** Add markers or update position of existing markers, to highlight the `pointed` grid cell.
     * Remove existing markers, if `pointed` is `undefined`. */
    MarkerBehavior.prototype.drawMarkers = function (pointed) {
        if (!this.state.dom)
            return;
        var xIndex = ((pointed === null || pointed === void 0 ? void 0 : pointed.xIndex) !== undefined) ? pointed.xIndex : this.state.xDomain.index.get(pointed === null || pointed === void 0 ? void 0 : pointed.x);
        var yIndex = ((pointed === null || pointed === void 0 ? void 0 : pointed.yIndex) !== undefined) ? pointed.yIndex : this.state.yDomain.index.get(pointed === null || pointed === void 0 ? void 0 : pointed.y);
        this.currentlyMarked.xIndex = xIndex;
        this.currentlyMarked.yIndex = yIndex;
        var xCoord = (xIndex !== undefined) ? this.state.scales.worldToCanvas.x(xIndex) : undefined;
        var yCoord = (yIndex !== undefined) ? this.state.scales.worldToCanvas.y(yIndex) : undefined;
        var width = (0, scales_1.scaleDistance)(this.state.scales.worldToCanvas.x, 1);
        var height = (0, scales_1.scaleDistance)(this.state.scales.worldToCanvas.y, 1);
        var staticAttrs = { rx: this.params.markerCornerRadius, ry: this.params.markerCornerRadius };
        // Column marker
        if (xCoord !== undefined) {
            this.addOrUpdateMarker(class_names_1.Class.MarkerX, staticAttrs, {
                x: xCoord,
                y: this.state.boxes.canvas.ymin,
                width: width,
                height: scales_1.Box.height(this.state.boxes.canvas),
            });
        }
        else {
            this.removeMarker(class_names_1.Class.MarkerX);
        }
        // Row marker
        if (yCoord !== undefined) {
            this.addOrUpdateMarker(class_names_1.Class.MarkerY, staticAttrs, {
                x: this.state.boxes.canvas.xmin,
                y: yCoord,
                width: scales_1.Box.width(this.state.boxes.canvas),
                height: height,
            });
        }
        else {
            this.removeMarker(class_names_1.Class.MarkerY);
        }
        // Cell marker
        if (xCoord !== undefined && yCoord !== undefined) {
            this.addOrUpdateMarker(class_names_1.Class.Marker, staticAttrs, {
                x: xCoord, y: yCoord,
                width: width,
                height: height,
            });
        }
        else {
            this.removeMarker(class_names_1.Class.Marker);
        }
    };
    MarkerBehavior.prototype.addOrUpdateMarker = function (className, staticAttrs, dynamicAttrs) {
        if (!this.state.dom)
            return;
        var marker = this.state.dom.svg.selectAll('.' + className).data([1]);
        (0, utils_1.attrd)(marker.enter().append('rect'), tslib_1.__assign(tslib_1.__assign({ class: className }, staticAttrs), dynamicAttrs));
        (0, utils_1.attrd)(marker, dynamicAttrs);
    };
    MarkerBehavior.prototype.removeMarker = function (className) {
        if (!this.state.dom)
            return;
        this.state.dom.svg.selectAll('.' + className).remove();
    };
    return MarkerBehavior;
}(extension_1.BehaviorBase));
exports.MarkerBehavior = MarkerBehavior;
/** Adds behavior that highlights hovered grid cell and column and row */
exports.MarkerExtension = extension_1.Extension.fromBehaviorClass({
    name: 'builtin.marker',
    defaultParams: exports.DefaultMarkerExtensionParams,
    behavior: MarkerBehavior,
});
